import {
  Button,
  Checkbox,
  DatePicker,
  Form,
  Input,
  InputNumber,
  notification,
  Tooltip,
} from "antd";
import FormInput from "components/FormInput/FormInput";
import React, { useEffect, useState } from "react";
import { numberWithCommas } from "shared/services/Utility";
import { FormInstance } from "antd/es/form";
import { ReactComponent as IconSave } from "../../../assets/images/right-border.svg";
import { ReactComponent as IconAdd } from "../../../assets/images/add_round.svg";
import { ReactComponent as IconRemove } from "../../../assets/images/fail.svg";
import "../PayoutInvoices/PayoutInvoices.scss";
import { useSelector } from "react-redux";
import { RootState } from "shared/redux/store";
import moment from "moment";
import { act } from "react-dom/test-utils";
import API_SERVICE from "shared/services/api-service";
import AppLoading from "shared/components/AppLoading/AppLoading";

interface IPayoutPayoutProcessedRow {
  payout: any;
  columns: any;
  selectedInvoices: string[];
  setSelectedInvoices: React.Dispatch<React.SetStateAction<string[]>>;
  formPayout: FormInstance<any>;
}

const PayoutProcessedRow: React.FunctionComponent<IPayoutPayoutProcessedRow> = (
  props: IPayoutPayoutProcessedRow
) => {
  const { payout, columns, selectedInvoices, setSelectedInvoices, formPayout } =
    props;

  const { appColors }: any = useSelector((state: RootState) => state.common);
  const { tenantInfo }: any = useSelector((state: RootState) => state.tenant);

  const [status, setStatus] = useState("");
  const [actionList, setActionList] = useState(payout?.actionList);
  const [loading, setLoading] = useState(false);

  const checked = selectedInvoices?.some(
    (item: any) => item == payout?.invoiceId
  );

  useEffect(() => {
    if ((payout?.actionList?.length ?? 0) == 0) {
      if (tenantInfo.connectorInvoicingEnabled) {
        setActionList([{}]);
      }
    } else {
      setActionList(payout?.actionList);
    }
  }, []);

  useEffect(() => {
    if (!checked) {
      setStatus("");
    }
  }, [checked]);

  const updateInvoice = (values, index) => {
    const params = {
      amount: values[`amount${payout.invoiceId}${index}`],
      comment: values[`comment${payout.invoiceId}${index}`],
      date: values[`date${payout.invoiceId}${index}`],
      utrNumber: values[`utrNo${payout.invoiceId}${index}`],
      stage: null,
      invoiceId: payout?.invoiceId,
    };
    setLoading(true);
    API_SERVICE.updateInvoice(params)
      .then(({ data }) => {
        const tmp = [...actionList];
        tmp.pop();
        tmp.push(params);
        setActionList(tmp);
      })
      .catch((e: any) =>
        notification.error({ message: API_SERVICE.handleErrors(e) })
      )
      .finally(() => setLoading(false));
  };

  const renderColumn = (data) => {
    if (data?.render) {
      return data.render(payout);
    }
    if (data?.type == "checkbox") {
      return (
        <Checkbox
          checked={checked}
          onChange={(e: any) => {
            if (e.target.checked) {
              setSelectedInvoices([...selectedInvoices, payout?.invoiceId]);
            } else {
              setSelectedInvoices(
                selectedInvoices?.filter(
                  (item: any) => item != payout?.invoiceId
                )
              );
            }
          }}
        />
      );
    }
    let value: any = "";
    if (Array.isArray(data?.dataIndex)) {
      value = payout;
      data?.dataIndex?.map((item: any) => {
        value = value?.[`${item}`];
      });
    } else {
      value = payout[`${data.dataIndex}`];
    }
    if (data?.showTooltip) {
      return (
        <Tooltip title={value}>
          <span style={{ textOverflow: "ellipsis", overflow: "hidden" }}>
            {value}
          </span>
        </Tooltip>
      );
    }
    if (data.isAmount) {
      return `Rs. ${numberWithCommas(value)}`;
    }
    return value;
  };

  const disableDate = (current) => {
    return current && current > new Date();
  };

  const renderDetails = (detail: any, index: number) => {
    const isAdd =
      actionList.length - 1 == index &&
      Object.keys(actionList.at(-1).detail ?? {}).length == 0;
    const isDisable = Object.keys(detail ?? {}).length > 0;
    return (
      <Form
        name={`payout${payout.invoiceId}`}
        className="payout-invoices-row-details"
        onFinish={(values) => updateInvoice(values, index)}
        initialValues={{
          [`date${payout.invoiceId}${index}`]:
            detail?.date && moment(detail?.date),
          [`amount${payout.invoiceId}${index}`]: detail?.amount,
          [`utrNo${payout.invoiceId}${index}`]: detail?.utrNo,
          [`comment${payout.invoiceId}${index}`]: detail?.comment,
        }}
      >
        <Form.Item
          style={{ width: "200px" }}
          name={`date${payout.invoiceId}${index}`}
          rules={[
            {
              required: true,
              message: `Please select Date`,
            },
          ]}
        >
          <DatePicker
            className="custom-input"
            size="large"
            placeholder="Date*"
            disabled={isDisable}
            disabledDate={disableDate}
          />
        </Form.Item>
        <Form.Item
          name={`amount${payout.invoiceId}${index}`}
          rules={[
            {
              required: true,
              message: `Please enter Amount`,
            },

            () => ({
              validator(_, value) {
                let amountApproved = actionList.map((item) => Number(item?.amount ?? 0));
                const total = amountApproved.reduce((a, b) => a + b, 0);
                if (value == 0) {
                  return Promise.reject(
                    "Please enter valid amount"
                  );
                }
                if (isNaN(value)) {
                  return Promise.reject(
                    "Please enter valid amount"
                  );
                }
                const availbleAmount = payout.netPayableAmount - total;
                if (value > availbleAmount) {
                  return Promise.reject(
                    `Please enter less amount than ${availbleAmount}`
                  );
                }
                return Promise.resolve();
              },
            }),
          ]}
        >
          <InputNumber
            className="custom-input-number"
            formatter={(value) => numberWithCommas(value)}
            placeholder="Amount*"
            disabled={isDisable}
          />
        </Form.Item>
        <FormInput
          name={`utrNo${payout.invoiceId}${index}`}
          placeholder="UTR Number"
          removeDefaultCss
          isDisabled={isDisable}
        />
        {isDisable ? (
          <div className="PP-comment-div">
            <Tooltip title={detail?.comment}>
              <span className="span-single-line">{detail?.comment}</span>
            </Tooltip>
          </div>
        ) : (
          <FormInput
            name={`comment${payout.invoiceId}${index}`}
            placeholder={"Comment"}
            removeDefaultCss
            requiredLabel="Comment"
            isDisabled={isDisable}
          />
        )}
        <div style={{ display: "flex", alignItems: "center" }}>
          {isDisable ? (
            <Tooltip title="Add new payment">
              <Button
                className="border-icon"
                style={
                  {
                    "--bgColor": appColors?.appPrimaryColor ?? "",
                    "--width": "25px",
                  } as any
                }
                size="small"
                type="text"
                hidden={
                  !isAdd ||
                  !tenantInfo.connectorInvoicingEnabled ||
                  payout?.invoiceStage?.toUpperCase() !== "PARTIALLY_PROCESSED"
                }
                onClick={() => {
                  setActionList([...actionList, {}]);
                }}
                icon={<IconAdd />}
              />
            </Tooltip>
          ) : (
            <>
              <Button
                className="border-icon"
                htmlType="submit"
                style={{ "--bgColor": appColors?.appPrimaryColor ?? "" } as any}
                size="small"
                type="text"
                onClick={() => {}}
                icon={<IconSave />}
              />
              <Button
                className="border-icon"
                style={
                  {
                    "--bgColor": appColors?.appSecondaryColor ?? "#C71C8E",
                    "--width": "22px",
                  } as any
                }
                size="small"
                type="text"
                onClick={() => {
                  const tmp = [...actionList];
                  tmp.pop();
                  setActionList(tmp);
                }}
                icon={<IconRemove />}
              />
            </>
          )}
        </div>
      </Form>
    );
  };

  return (
    <>
      <div className="payout-invoices-row">
        {columns?.map((data: any, index) => {
          let styleExtra: any = {};
          if (data?.fixed == "right") {
            let right = 0;
            if (columns.length - 1 != index) {
              for (let i = index + 1; i < columns.length; i++) {
                right = right + (columns.at(i)?.width ?? 120);
              }
            }
            let sty = {};
            if (columns.at(index - 1)?.fixed !== "right") {
              sty = { borderLeft: "1px solid #DFE0EB" };
            }
            styleExtra = {
              position: "sticky",
              right: right,
              zIndex: 5,
              ...sty,
            };
          }
          return (
            <div
              style={{
                width: data?.width ?? "120px",
                ...styleExtra,
              }}
              className={"payout-invoices-col " + (data?.className ?? "")}
            >
              {renderColumn(data)}
            </div>
          );
        })}
      </div>
      {checked &&
        actionList?.map((detail: any, index: number) => {
          return renderDetails(detail, index);
        })}
      {loading && <AppLoading />}
    </>
  );
};

export default PayoutProcessedRow;
